import { Component, Input, OnInit } from '@angular/core';
import { State } from '@app/core/features';
import { FetchProducts } from '@app/core/features/product/product.actions';
import { Product } from '@app/core/features/product/product.models';
import { selectors as productSelectors } from '@app/core/features/product/product.selectors';
import { BaseComponent } from '@app/shared/components/base/base/base.component';
import { getStaticMonikerImagePath } from '@app/utils';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-moniker-image',
  templateUrl: './moniker-image.component.html',
  styleUrls: ['./moniker-image.component.scss']
})
export class MonikerImageComponent extends BaseComponent implements OnInit {
  @Input() productSku: string;
  @Input() isComingSoon: boolean;
  public urlMonikerImage: string;

  constructor(private store: Store<State>) { super(); }

  ngOnInit(): void {
    this.store.pipe(productSelectors.getProductList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Product[]) => {
        if (data && data.length > 0) {
          let findProduct = data.find(x => x.sku === this.productSku);
          this.urlMonikerImage = findProduct ? getStaticMonikerImagePath(findProduct.monikerImage, this.isComingSoon) : getStaticMonikerImagePath('', false);
        } else {
          this.store.dispatch(new FetchProducts({ includeInactive: false, includeImage: false }));
        }
      });
  }
}
